import { render } from "./pon-tree-page.vue?vue&type=template&id=c1116ee0"
import script from "./pon-tree-page.vue?vue&type=script&lang=js"
export * from "./pon-tree-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__